










import {Component, Vue, Prop, Watch} from 'vue-property-decorator'

@Component
export default class BrandCategoryFilter extends Vue {
  @Prop({required: true}) sortInfo!: string

  public createTimeClass = ""
  public priceClass = ""
  public defaultClass = ""

  @Watch('sortInfo')
  onSortInfoChange(){
    this.updateArrow()
  }
  public updateArrow(){
    switch (this.sortInfo) {
      case 'createTime-desc':
        this.createTimeClass = "arrowDown";
        this.priceClass = "";
        this.defaultClass = "";
        break;
      case 'createTime-asc':
        this.createTimeClass = "arrowUp";
        this.priceClass = "";
        this.defaultClass = "";
        break;
      case 'sellingPrice-desc':
        this.priceClass = "arrowDown";
        this.createTimeClass = "";
        this.defaultClass = "";
        break;
      case 'sellingPrice-asc':
        this.priceClass = "arrowUp";
        this.createTimeClass = "";
        this.defaultClass = "";
        break;
      case 'default':
        this.priceClass = "";
        this.createTimeClass = "";
        this.defaultClass = "selected";
    }
  }

  created(){
    this.updateArrow()
  }


  public filterByTime(){
    if(this.sortInfo === "createTime-desc"){
      this.$emit('filterByTime', 1)
    }else{
      this.$emit('filterByTime', 0)
    }
  }

  public filterByPrice(){
    if(this.sortInfo === "sellingPrice-desc"){
      this.$emit('filterByPrice', 1)
    }else{
      this.$emit('filterByPrice', 0)
    }
  }

  public filterByDefault(){
    if(this.sortInfo !== 'default'){
      this.$emit('default')
    }
  }
}
